import clsx from 'clsx';
import React, { forwardRef } from 'react';
export const TabsPanel = forwardRef(function TabsPanel(props, ref) {
    const { children, className, label, description, defaultSelected, ...rest } = props;
    return (React.createElement("div", { ...rest, className: clsx('mollie-ui-tabs-panel', className), tabIndex: -1, ref: ref }, children));
});
TabsPanel.displayName = 'Tabs.Panel';
//# sourceMappingURL=TabsPanel.js.map